import React from 'react';

export default function PaymentTypeSelector({ isRecurring, onChange }) {
    const options = [
        {
            value: false,
            title: 'One Time Payment',
            subtitle: 'Make a single payment for this period.',
            icon: 'pi pi-credit-card',
            id: 'paymentTypeOneTime'
        },
        {
            value: true,
            title: 'Subscription',
            subtitle: 'Securely save payment details and automatically charge for future premiums.',
            icon: 'pi pi-sync',
            id: 'paymentTypeRecurring'
        }
    ];

    return (
        <div className="w-full mt-2 flex flex-col gap-3">
            {options.map((opt, index) => {
                const selected = isRecurring === opt.value;
                return (
                    <label 
                        key={opt.id}
                        htmlFor={opt.id}
                        className={`flex items-center p-4 w-full rounded-2xl border-2 transition-all cursor-pointer shadow-sm hover:shadow-md ${selected ? 'border-primary bg-primary/5' : 'border-base-200 bg-base-100 hover:border-base-300'}`}
                    >
                        <input 
                            className="radio radio-primary radio-md mr-4" 
                            type="radio" 
                            name="paymentType" 
                            id={opt.id}
                            aria-label={opt.title}
                            value={opt.value} 
                            checked={selected}
                            onChange={() => onChange(opt.value)}
                        />
                        <div className="flex-1">
                            <span className="block font-bold text-base-content text-lg mb-1">{opt.title}</span>
                            <span className="block text-sm text-base-content/70">{opt.subtitle}</span>
                        </div>
                        <div className="ml-4 flex-shrink-0">
                            <i className={`${opt.icon} text-2xl ${selected ? 'text-primary' : 'text-base-content/30'}`}></i>
                        </div>
                    </label>
                );
            })}
        </div>
    );
}
